<template>
  <div>
    <custom-callout
      apply-border-top
      has-border
      has-toggle
      has-gradient
      controlled
      :border-color="item.status.color"
      :opened="item.isOpen"
      @click:open="() => toggle(false)"
    >
      <div class="row pt-3">
        <div
          class="col-12 col-lg-2 border-right d-flex justify-content-center align-items-center"
        >
          <custom-balloon
            dot
            :text="item.status?.name"
            :background-color="item.status?.color"
          />
        </div>
        <div class="col-12 col-lg-8">
          <div class="row">
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Nombre de Usuario:"
                label-class="text-gray font-weight-light"
                :value="item.name"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Correo Electrónico:"
                label-class="text-gray font-weight-light"
                :value="item.email"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mb-3">
              <span class="data-title d-block">Télefono:</span>
              <span class="font-16 color-black">
                {{ item.telephone | phone }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Fecha y Hora de Inscripción:"
                label-class="text-gray font-weight-light"
                :value="$options.filters.dateTime(item.enrollmentDate)"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Fecha y Hora de Participación:"
                label-class="text-gray font-weight-light"
                :value="$options.filters.dateTime(item.participationDate)"
                class="span-student ml-0"
              />
            </div>
            <div class="col-12 col-lg-4 mb-3">
              <custom-input-display
                label="Score:"
                label-class="text-gray font-weight-light"
                :value="item.score"
                class="span-student ml-0"
              />
            </div>
          </div>
        </div>
        <div
          class="col-12 col-lg-2 d-flex justify-content-center align-items-center"
        >
          <drop-down always-show-dropdown :items="actionItems" />
        </div>
      </div>
      <template #edition>
        <div class="bg-gray p-2">
          <div class="bg-white p-3 rounded">
            <div v-if="isNotifyAbsenceVisible">
              <notify-absence
                :is-read-only="isAbsent"
                :reason="item.absenceReason"
                @save="saveNotifyAbsence"
                @cancel="toggle"
              />
            </div>
            <div v-if="isMetricsVisible">
              <metrics :participantId="item.id" />
            </div>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomInputDisplay from 'CustomInputDisplay';
import ActionButton from 'ActionButton';
import CustomBalloon from 'custom-balloon';
import WorkshopStatus from '@/utils/constants/operations-dashboard-management/workshopStatuses';
import DropDown from 'dropdown';
import reportService from '@/services/report';
import mixAlert from '@/mixin/alert.mixin';
import NotifyAbsence from './NotifyAbsence.vue';
import Metrics from './Metrics.vue';

const ACTIONS = {
  METRICS: 1,
  NOTIFYABSENCE: 2,
};

export default {
  name: 'ParticipantRow',
  components: {
    CustomCallout,
    CustomInputDisplay,
    ActionButton,
    CustomBalloon,
    DropDown,
    NotifyAbsence,
    Metrics,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: () => 0,
    },
    willGenerateCertificate: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      action: null,
    };
  },
  computed: {
    isAbsent() {
      return Boolean(WorkshopStatus.Absent == this.item?.status?.id);
    },
    isRegistered() {
      return Boolean(WorkshopStatus.Registered == this.item?.status?.id);
    },
    canNotifyAbsence() {
      return !this.isDone && this.isRegistered;
    },
    isDone() {
      const done = [WorkshopStatus.Completed, WorkshopStatus.Finished].includes(
        this.item?.status?.id
      );
      return done && Boolean(this.item?.endDate);
    },
    actionItems() {
      return [
        {
          name: this.isAbsent ? 'Ver Razón de Ausencia' : 'Notificar Ausencia',
          icon: 'fas fa-user text-green',
          visible: this.isAbsent || this.canNotifyAbsence,
          click: () => this.toggle(true, ACTIONS.NOTIFYABSENCE),
        },
        {
          name: 'Ver Métricas',
          icon: 'fas fa-file-chart-line text-green',
          visible: this.item?.status?.id >= WorkshopStatus.Registered,
          click: () => this.toggle(true, ACTIONS.METRICS),
        },
        {
          name: 'Descargar Certificado',
          icon: 'fas fa-file-download text-green',
          visible: this.isDone && this.willGenerateCertificate,
          click: () => this.handleDownloadCertificate(),
        },
      ];
    },
    isNotifyAbsenceVisible() {
      return Boolean(this.action === ACTIONS.NOTIFYABSENCE);
    },
    isMetricsVisible() {
      return Boolean(this.action === ACTIONS.METRICS);
    },
  },
  methods: {
    async handleDownloadCertificate() {
      await reportService.downloadWorkshopCertificate(this.item.id);
    },
    async saveNotifyAbsence(model) {
      const response = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea notificar la ausencia de este participante?',
        'Sí',
        'No'
      );
      if (!response) return;
      this.$emit('save-absense', { ...model, id: this.item.id });
    },
    toggle(opened = !this.item.isOpen, action) {
      this.item.isOpen = opened;
      this.action = action;
      this.$emit('toggle', this.item);
    },
  },
};
</script>
